import { useStoreMap } from 'effector-react';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { GameCell, gameModel } from 'entities/game';
import { TURN_STATUSES } from 'shared/api';
import { gameFieldModel } from '../../model';
import cls from './game-field-multiplier.module.scss';

export type GameFieldMultiplierProps = {
	rowIndex: number;
} & Omit<ComponentProps<'button'>, 'disabled'>;

export const GameFieldMultiplier = ({ rowIndex, ...props }: GameFieldMultiplierProps) => {
	const { t } = useTranslation();

	const multiplier = useStoreMap({
		store: gameModel.$multipliers,
		keys: [rowIndex],
		fn: (multipliers, [row]) => multipliers?.[row] ?? 1,
	});

	const isPassed = useStoreMap({
		store: gameFieldModel.$multipliersData,
		keys: [rowIndex],
		fn: ({ turnStatus, multipliers, turnMultiplier }, [row]) =>
			multipliers !== null &&
			turnStatus !== TURN_STATUSES.lose &&
			multipliers[row] <= turnMultiplier,
	});

	return (
		<GameCell
			bgVariant='dark'
			data-passed={isPassed || undefined}
			classNames={{
				root: cls.gameFieldMultiplierRoot,
				label: cls.gameFieldMultiplierLabel,
			}}
			{...props}
		>
			{multiplier}
			{t('multiplier')}
		</GameCell>
	);
};
